import React, { useState, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";
import "./DailyPurchases.css";

// ── Catalogue Initial Immédiat (0ms de chargement, rendu instantané) ──
const INITIAL_CATEGORIES = [
  {
    _id: "cat_fournitures",
    name: "Fournitures de bureau",
    icon: "📁",
    color: "#2563eb",
    description: "Papeterie, stylos, agrafes, rouleaux thermiques",
    subCategories: [
      { name: "Agrafe 24/6", unit: "boîte", estimatedPrice: 2.5 },
      { name: "Agrafeuse de bureau", unit: "pièce", estimatedPrice: 15.0 },
      { name: "Stylo à bille (Bleu/Noir)", unit: "paquet", estimatedPrice: 4.5 },
      { name: "Rouleau de caisse thermique 80mm", unit: "rouleau", estimatedPrice: 1.8 },
      { name: "Papier A4 (Ramette 500f)", unit: "ramette", estimatedPrice: 14.5 },
      { name: "Post-it & Blocs-notes", unit: "paquet", estimatedPrice: 3.2 },
      { name: "Surligneurs fluorescents", unit: "pack", estimatedPrice: 5.0 },
      { name: "Ruban adhésif (Scotch)", unit: "pièce", estimatedPrice: 3.5 },
      { name: "Correcteur ruban/liquide", unit: "pièce", estimatedPrice: 2.2 }
    ]
  },
  {
    _id: "cat_hygiene",
    name: "Produits d'entretien & Hygiène",
    icon: "🧹",
    color: "#059669",
    description: "Nettoyage, javel, savon, papier essuie-tout",
    subCategories: [
      { name: "Désinfectant multi-surfaces", unit: "litre", estimatedPrice: 6.5 },
      { name: "Javel désinfectante 5L", unit: "bidon", estimatedPrice: 8.0 },
      { name: "Lave-sol parfumé 5L", unit: "bidon", estimatedPrice: 12.0 },
      { name: "Papier essuie-tout professionnel", unit: "rouleau", estimatedPrice: 7.5 },
      { name: "Papier hygiénique (Pack 24)", unit: "pack", estimatedPrice: 18.0 },
      { name: "Savon liquide mains 5L", unit: "bidon", estimatedPrice: 14.0 },
      { name: "Sacs poubelle renforcés 100L", unit: "rouleau", estimatedPrice: 6.0 },
      { name: "Éponges & Lavettes microfibres", unit: "pack", estimatedPrice: 4.5 },
      { name: "Gants de ménage", unit: "paire", estimatedPrice: 2.5 }
    ]
  },
  {
    _id: "cat_emballage",
    name: "Consommables & Emballages",
    icon: "📦",
    color: "#d97706",
    description: "Sacs kraft, rubans adhésifs, étiquettes",
    subCategories: [
      { name: "Sacs kraft boutique", unit: "lot 100", estimatedPrice: 22.0 },
      { name: "Étiquettes code-barres thermiques", unit: "rouleau", estimatedPrice: 11.0 },
      { name: "Film étirable d'emballage", unit: "rouleau", estimatedPrice: 16.5 },
      { name: "Ruban adhésif d'emballage 'Fragile'", unit: "rouleau", estimatedPrice: 4.0 }
    ]
  },
  {
    _id: "cat_maintenance",
    name: "Petit outillage & Maintenance",
    icon: "🔧",
    color: "#dc2626",
    description: "Piles, ampoules, multiprises, câbles",
    subCategories: [
      { name: "Piles AA (Pack de 4)", unit: "pack", estimatedPrice: 6.0 },
      { name: "Piles AAA (Pack de 4)", unit: "pack", estimatedPrice: 6.0 },
      { name: "Ampoules LED E27", unit: "pièce", estimatedPrice: 5.5 },
      { name: "Rallonge multiprise 5m", unit: "pièce", estimatedPrice: 18.0 },
      { name: "Câble réseau RJ45 3m", unit: "pièce", estimatedPrice: 6.5 }
    ]
  },
  {
    _id: "cat_cafeteria",
    name: "Cafétéria & Accueil Clients",
    icon: "☕",
    color: "#7c3aed",
    description: "Café, sucre, gobelets, eau minérale",
    subCategories: [
      { name: "Café en grains/moulu 1kg", unit: "kg", estimatedPrice: 28.0 },
      { name: "Capsules de café expresso", unit: "boîte 50", estimatedPrice: 45.0 },
      { name: "Gobelets en carton", unit: "lot 100", estimatedPrice: 7.0 },
      { name: "Sucre en bûchettes", unit: "boîte 200", estimatedPrice: 9.0 },
      { name: "Touillettes en bois", unit: "paquet 500", estimatedPrice: 4.0 },
      { name: "Bouteilles d'eau minérale 1.5L", unit: "pack de 6", estimatedPrice: 4.8 }
    ]
  }
];

const INITIAL_LOCATIONS = [
  { name: "Twin Park - Tunisia Mall", category: "Twin Park" },
  { name: "Twin Park- Manar City", category: "Twin Park" },
  { name: "Twin park - Jardins d'eL Menzah", category: "Twin Park" },
  { name: "Jump Zone Mall of Djerba", category: "Twin Park" },
  { name: "Champion Lafayette", category: "Wellness" },
  { name: "Carthage Land-Hammamet", category: "Wellness" },
  { name: "Palmarium", category: "Wellness" },
  { name: "Zaphir", category: "Wellness" },
  { name: "Tunis City", category: "Wellness" },
  { name: "Azur City", category: "Wellness" },
  { name: "Claridge", category: "Wellness" },
  { name: "TP-Manar City", category: "Wellness" },
  { name: "TP-Tunisia Mall", category: "Wellness" },
  { name: "TP-Jardins D'el Menzah", category: "Wellness" },
  { name: "Manar City", category: "Wellness" },
  { name: "Tunisia Mall", category: "Wellness" },
  { name: "Shell-Grombalia", category: "Wellness" },
  { name: "Shell-Sidi Khlifa", category: "Wellness" },
  { name: "Agil-Sidi Khlifa", category: "Wellness" },
  { name: "Agil-Bourjin", category: "Wellness" },
  { name: "Agil-Jem", category: "Wellness" },
  { name: "Total-Grombalia", category: "Wellness" },
  { name: "Total-Bourjin", category: "Wellness" },
  { name: "Total-Jem", category: "Wellness" },
  { name: "Sfax Palace", category: "Wellness" },
  { name: "Djerba Mall", category: "Wellness" },
  { name: "Bourgo Mall", category: "Wellness" },
  { name: "TP-Bourgo Mall", category: "Wellness" },
  { name: "Mickey Hammamet", category: "Wellness" }
];

const CaisseAchatTactile = ({ onRequestCreated, onNavigateToSuivi }) => {
  const currentUser = useSelector((state) => state.AuthReducer?.user);

  const isAdmin =
    currentUser?.role === "admin" || currentUser?.role === "useradmin";
  const isController =
    currentUser?.role === "controleur" ||
    Boolean(currentUser?.fonction && currentUser.fonction.toLowerCase().includes("control"));
  const isControllerOrAdmin = Boolean(isAdmin || isController);

  // ── États Données ──
  const [locations, setLocations] = useState(INITIAL_LOCATIONS);
  const [selectedLocation, setSelectedLocation] = useState("");
  const [categories, setCategories] = useState(INITIAL_CATEGORIES);

  // Mode de navigation : null = Vue des familles (Level 1), string id = Vue des articles de la famille (Level 2)
  const [selectedFamilyId, setSelectedFamilyId] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);

  // ── Panier de Demande d'Achat ──
  const [cart, setCart] = useState([]);
  const [priority, setPriority] = useState("normal");
  const [generalNotes, setGeneralNotes] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [successModal, setSuccessModal] = useState(null);

  // ── Modal Ajout Article Personnalisé / Hors Catalogue ──
  const [showCustomModal, setShowCustomModal] = useState(false);
  const [customItem, setCustomItem] = useState({
    articleName: "",
    categoryName: "Fournitures de bureau",
    subCategoryName: "Divers",
    unit: "pièce",
    requestedQuantity: 1,
    estimatedUnitPrice: 0,
    notes: ""
  });

  // 1. Initialisation de l'emplacement utilisateur
  useEffect(() => {
    const userLoc = currentUser?.localisation || localStorage.getItem("localisation");
    if (userLoc) {
      const found = locations.find(
        (l) => l.name?.toLowerCase() === userLoc.toLowerCase() || l._id === userLoc
      );
      setSelectedLocation(found ? found.name : userLoc);
    } else if (locations.length > 0) {
      setSelectedLocation(locations[0].name);
    }
  }, [currentUser]);

  // 2. Synchronisation en arrière-plan avec le serveur (rapide et asynchrone)
  const syncWithServer = async () => {
    try {
      // Chargement en parallèle des emplacements et catégories
      const [locRes, catRes] = await Promise.allSettled([
        axios.get("/api/Locations/getAllLocations"),
        axios.get("/api/daily-purchases/categories")
      ]);

      if (locRes.status === "fulfilled" && Array.isArray(locRes.value.data) && locRes.value.data.length > 0) {
        setLocations(locRes.value.data);
      }

      if (catRes.status === "fulfilled" && Array.isArray(catRes.value.data) && catRes.value.data.length > 0) {
        const hasArticles = catRes.value.data.some((c) => c.subCategories?.length > 0);
        if (hasArticles) {
          setCategories(catRes.value.data);
        }
      }
    } catch (e) {
      console.warn("Sync background notice:", e);
    }
  };

  useEffect(() => {
    syncWithServer();
  }, []);

  // Extraction de tous les articles
  const allArticles = useMemo(() => {
    const items = [];
    categories.forEach((cat) => {
      (cat.subCategories || []).forEach((sub, idx) => {
        items.push({
          id: `${cat._id || cat.name}_${sub._id || sub.name}_${idx}`,
          categoryId: String(cat._id || cat.name),
          categoryName: cat.name,
          categoryIcon: cat.icon || "📦",
          categoryColor: cat.color || "#2563eb",
          subCategoryName: sub.name,
          articleName: sub.name,
          unit: sub.unit || "pièce",
          estimatedUnitPrice: Number(sub.estimatedPrice) || 0,
          description: sub.defaultDescription || ""
        });
      });
    });
    return items;
  }, [categories]);

  // Famille actuellement sélectionnée
  const activeFamily = useMemo(() => {
    if (!selectedFamilyId) return null;
    return categories.find(
      (c) =>
        String(c._id) === String(selectedFamilyId) ||
        String(c.name).toLowerCase() === String(selectedFamilyId).toLowerCase()
    );
  }, [categories, selectedFamilyId]);

  // Articles filtrés (Recherche globale OU articles de la famille sélectionnée)
  const displayedArticles = useMemo(() => {
    if (searchTerm.trim()) {
      const term = searchTerm.toLowerCase();
      return allArticles.filter(
        (art) =>
          art.articleName.toLowerCase().includes(term) ||
          art.categoryName.toLowerCase().includes(term) ||
          (art.description && art.description.toLowerCase().includes(term))
      );
    }

    if (selectedFamilyId && activeFamily) {
      return (activeFamily.subCategories || []).map((sub, idx) => ({
        id: `${activeFamily._id}_${sub.name}_${idx}`,
        categoryId: String(activeFamily._id),
        categoryName: activeFamily.name,
        categoryIcon: activeFamily.icon || "📦",
        categoryColor: activeFamily.color || "#2563eb",
        subCategoryName: sub.name,
        articleName: sub.name,
        unit: sub.unit || "pièce",
        estimatedUnitPrice: Number(sub.estimatedPrice) || 0,
        description: sub.defaultDescription || ""
      }));
    }

    return [];
  }, [allArticles, activeFamily, selectedFamilyId, searchTerm]);

  // ── Actions Panier ──
  const addToCart = (article) => {
    setCart((prev) => {
      const existingIdx = prev.findIndex(
        (item) => item.articleName.toLowerCase() === article.articleName.toLowerCase()
      );
      if (existingIdx !== -1) {
        const updated = [...prev];
        updated[existingIdx].requestedQuantity += 1;
        updated[existingIdx].estimatedTotalPrice =
          updated[existingIdx].requestedQuantity * updated[existingIdx].estimatedUnitPrice;
        return updated;
      } else {
        return [
          ...prev,
          {
            ...article,
            requestedQuantity: 1,
            estimatedTotalPrice: article.estimatedUnitPrice || 0,
            notes: ""
          }
        ];
      }
    });
  };

  const updateQuantity = (index, delta) => {
    setCart((prev) => {
      const updated = [...prev];
      const newQty = (updated[index].requestedQuantity || 1) + delta;
      if (newQty <= 0) {
        return updated.filter((_, i) => i !== index);
      }
      updated[index].requestedQuantity = newQty;
      updated[index].estimatedTotalPrice =
        newQty * (updated[index].estimatedUnitPrice || 0);
      return updated;
    });
  };

  const handleDirectQuantityChange = (index, value) => {
    const val = parseFloat(value);
    setCart((prev) => {
      const updated = [...prev];
      if (isNaN(val) || val <= 0) {
        updated[index].requestedQuantity = 1;
      } else {
        updated[index].requestedQuantity = val;
      }
      updated[index].estimatedTotalPrice =
        updated[index].requestedQuantity * (updated[index].estimatedUnitPrice || 0);
      return updated;
    });
  };

  const removeItem = (index) => {
    setCart((prev) => prev.filter((_, i) => i !== index));
  };

  const clearCart = () => {
    setCart([]);
    setGeneralNotes("");
  };

  // Ajout d'article personnalisé
  const handleAddCustomItem = () => {
    if (!customItem.articleName.trim()) return;

    const newItem = {
      id: `custom_${Date.now()}`,
      categoryId: null,
      categoryName: customItem.categoryName || "Divers",
      categoryIcon: "✨",
      categoryColor: "#64748b",
      subCategoryName: customItem.subCategoryName || "Article sur mesure",
      articleName: customItem.articleName.trim(),
      unit: customItem.unit || "pièce",
      requestedQuantity: Number(customItem.requestedQuantity) || 1,
      estimatedUnitPrice: Number(customItem.estimatedUnitPrice) || 0,
      estimatedTotalPrice:
        (Number(customItem.requestedQuantity) || 1) *
        (Number(customItem.estimatedUnitPrice) || 0),
      notes: customItem.notes || ""
    };

    setCart((prev) => [...prev, newItem]);
    setShowCustomModal(false);
    setCustomItem({
      articleName: "",
      categoryName: "Fournitures de bureau",
      subCategoryName: "Divers",
      unit: "pièce",
      requestedQuantity: 1,
      estimatedUnitPrice: 0,
      notes: ""
    });
  };

  // Totaux du panier
  const totalItemsCount = cart.reduce(
    (sum, item) => sum + (Number(item.requestedQuantity) || 0),
    0
  );
  const totalEstimatedCost = cart.reduce(
    (sum, item) => sum + (Number(item.estimatedTotalPrice) || 0),
    0
  );

  // Soumission
  const handleSubmitRequest = async () => {
    if (cart.length === 0) {
      alert("Votre panier d'achat est vide. Ajoutez des articles.");
      return;
    }

    if (!selectedLocation) {
      alert("Veuillez sélectionner un emplacement pour cette demande.");
      return;
    }

    setSubmitting(true);
    try {
      const locObj = locations.find(
        (l) => l.name === selectedLocation || l._id === selectedLocation
      );
      const locName = locObj ? locObj.name : selectedLocation;
      const locId = locObj ? locObj._id : null;

      const payload = {
        locationId: locId,
        locationName: locName,
        requestedByName: currentUser?.name || "Commercial",
        requestedByMatricule: currentUser?.matricule || "",
        priority,
        generalNotes,
        items: cart
      };

      const res = await axios.post("/api/daily-purchases/requests", payload);
      setSuccessModal(res.data.request);
      setCart([]);
      setGeneralNotes("");

      if (onRequestCreated) {
        onRequestCreated(res.data.request);
      }
    } catch (err) {
      console.error("Erreur soumission demande achat:", err);
      alert(
        err.response?.data?.error ||
          "Erreur lors de l'enregistrement de la demande d'achat."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="dp-pos-layout">
      {/* ── CATALOGUE TACTILE (GAUCHE) ── */}
      <div className="dp-pos-catalog">
        {/* Barre du haut : Emplacement & Recherche */}
        <div className="dp-pos-topbar">
          <div className="dp-location-selector-box">
            <label
              style={{
                fontSize: "0.78rem",
                fontWeight: "800",
                color: "#475569",
                textTransform: "uppercase",
                marginBottom: "4px",
                display: "block"
              }}
            >
              📍 Emplacement Demandeur {!isControllerOrAdmin ? "(Verrouillé)" : ""}
            </label>
            {isControllerOrAdmin ? (
              <select
                className="dp-location-select"
                value={selectedLocation}
                onChange={(e) => setSelectedLocation(e.target.value)}
              >
                {locations.map((loc, idx) => {
                  const locName = typeof loc === "string" ? loc : (loc.name || loc.localisation || loc._id);
                  const locCat = typeof loc === "object" && loc.category ? `(${loc.category})` : "";
                  const key = (typeof loc === "object" && loc._id) ? loc._id : `${locName}_${idx}`;
                  return (
                    <option key={key} value={locName}>
                      🏪 {locName} {locCat}
                    </option>
                  );
                })}
              </select>
            ) : (
              <div
                style={{
                  padding: "10px 14px",
                  background: "#f1f5f9",
                  border: "1.5px solid #cbd5e1",
                  borderRadius: "12px",
                  fontWeight: "800",
                  color: "#0f172a",
                  fontSize: "0.92rem",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px"
                }}
              >
                🏪 {selectedLocation || "Emplacement Assigné"} <span style={{ fontSize: "0.75rem", color: "#64748b", fontWeight: "600" }}>🔒</span>
              </div>
            )}
          </div>

          <div className="dp-search-box">
            <label
              style={{
                fontSize: "0.78rem",
                fontWeight: "800",
                color: "#475569",
                textTransform: "uppercase",
                marginBottom: "4px",
                display: "block"
              }}
            >
              🔍 Recherche Rapide d'Article
            </label>
            <div style={{ position: "relative" }}>
              <span className="dp-search-icon">🔍</span>
              <input
                type="text"
                className="dp-search-input"
                placeholder="Ex: Agrafe, Stylo, Javel, Papier A4..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              {searchTerm && (
                <button
                  onClick={() => setSearchTerm("")}
                  style={{
                    position: "absolute",
                    right: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    background: "none",
                    border: "none",
                    color: "#94a3b8",
                    cursor: "pointer",
                    fontSize: "1rem"
                  }}
                >
                  ✕
                </button>
              )}
            </div>
          </div>
        </div>

        {/* ── MODE 1 : VUE DES FAMILLES (NIVEAU 1) ── */}
        {!selectedFamilyId && !searchTerm.trim() ? (
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "16px",
                paddingBottom: "10px",
                borderBottom: "1px solid #f1f5f9",
                flexWrap: "wrap",
                gap: "8px"
              }}
            >
              <h5 style={{ margin: 0, fontWeight: "800", color: "#0f172a" }}>
                📂 Choisissez une Famille d'Achats :
              </h5>
              <div style={{ display: "flex", gap: "8px" }}>
                {onNavigateToSuivi && (
                  <button
                    className="dp-btn dp-btn-secondary"
                    style={{ padding: "6px 14px", fontSize: "0.82rem", fontWeight: "750" }}
                    onClick={onNavigateToSuivi}
                    title="Voir l'historique et l'avancement de mes demandes"
                  >
                    📦 Suivre mes Demandes
                  </button>
                )}
                <button
                  className="dp-btn dp-btn-primary"
                  style={{ padding: "6px 14px", fontSize: "0.82rem", fontWeight: "800" }}
                  onClick={() => setShowCustomModal(true)}
                >
                  ➕ Article Sur Mesure
                </button>
              </div>
            </div>

            <div className="dp-pos-families-grid">
              {categories.map((cat) => {
                const color = cat.color || "#2563eb";
                const count = (cat.subCategories || []).length;
                
                // Calcul du nombre d'articles de cette famille déjà dans le panier
                const inCartCount = cart.filter(
                  (item) => String(item.categoryId) === String(cat._id || cat.name) || item.categoryName === cat.name
                ).reduce((sum, item) => sum + (item.quantity || 1), 0);

                return (
                  <div
                    key={cat._id || cat.name}
                    className="dp-pos-family-big-card"
                    style={{
                      borderTop: `6px solid ${color}`,
                      background: `linear-gradient(180deg, ${color}0D 0%, #ffffff 50%)`
                    }}
                    onClick={() => setSelectedFamilyId(cat._id || cat.name)}
                  >
                    {inCartCount > 0 && (
                      <div className="dp-pos-family-badge-cart">
                        🛒 {inCartCount} dans panier
                      </div>
                    )}

                    <div
                      className="dp-pos-family-icon-box"
                      style={{
                        background: color,
                        boxShadow: `0 8px 20px ${color}4D`
                      }}
                    >
                      {cat.icon || "📦"}
                    </div>

                    <div style={{ width: "100%" }}>
                      <div className="dp-pos-family-info-title">{cat.name}</div>
                      <div className="dp-pos-family-info-count">
                        {count} article{count > 1 ? "s" : ""} disponible{count > 1 ? "s" : ""}
                      </div>
                    </div>

                    <div
                      className="dp-pos-family-action-pill"
                      style={{ background: color }}
                    >
                      <span>Voir les articles</span>
                      <span>➔</span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ) : (
          /* ── MODE 2 : VUE DES ARTICLES DE LA FAMILLE (NIVEAU 2) OU RECHERCHE ── */
          <div>
            {/* En-tête Drilldown */}
            <div className="dp-drilldown-header">
              <div style={{ display: "flex", alignItems: "center", gap: "14px", flexWrap: "wrap" }}>
                <button
                  className="dp-drilldown-back-btn"
                  onClick={() => {
                    setSelectedFamilyId(null);
                    setSearchTerm("");
                  }}
                >
                  ⬅ Toutes les Familles
                </button>

                {activeFamily && !searchTerm && (
                  <div className="dp-drilldown-active-title">
                    <div
                      className="dp-drilldown-active-icon"
                      style={{
                        background: activeFamily.color || "#2563eb",
                        boxShadow: `0 4px 12px ${activeFamily.color || "#2563eb"}55`
                      }}
                    >
                      {activeFamily.icon || "📦"}
                    </div>
                    <div>
                      <h4 className="dp-drilldown-active-name">
                        {activeFamily.name}
                      </h4>
                      <span style={{ fontSize: "0.82rem", color: "#64748b", fontWeight: "600" }}>
                        {(activeFamily.subCategories || []).length} article(s) dans cette famille
                      </span>
                    </div>
                  </div>
                )}

                {searchTerm && (
                  <div>
                    <h5 style={{ margin: 0, fontWeight: "800", color: "#0f172a" }}>
                      🔍 Résultats pour "{searchTerm}" ({displayedArticles.length} article(s))
                    </h5>
                  </div>
                )}
              </div>

              {/* Barre des Familles en Boutons Carrés de 2 cm */}
              <div className="dp-family-square-bar">
                {/* Bouton retour / toutes les familles en carré */}
                <button
                  className="dp-family-square-btn"
                  style={{
                    borderColor: "#0f172a",
                    background: "#0f172a",
                    color: "#ffffff"
                  }}
                  onClick={() => {
                    setSelectedFamilyId(null);
                    setSearchTerm("");
                  }}
                  title="Toutes les Familles"
                >
                  <span className="dp-family-square-icon">📂</span>
                  <span className="dp-family-square-label" style={{ color: "#ffffff" }}>
                    Toutes
                  </span>
                </button>

                {categories.map((c) => {
                  const isActive = String(selectedFamilyId) === String(c._id || c.name);
                  const catColor = c.color || "#2563eb";
                  
                  // Nombre d'articles de cette famille dans le panier
                  const inCartCount = cart.filter(
                    (item) => String(item.categoryId) === String(c._id || c.name) || item.categoryName === c.name
                  ).reduce((sum, item) => sum + (item.quantity || 1), 0);

                  return (
                    <button
                      key={c._id || c.name}
                      className={`dp-family-square-btn ${isActive ? "active" : ""}`}
                      style={{
                        borderColor: isActive ? catColor : "#cbd5e1",
                        background: isActive ? catColor : "#ffffff",
                        color: isActive ? "#ffffff" : "#0f172a"
                      }}
                      onClick={() => {
                        setSelectedFamilyId(c._id || c.name);
                        setSearchTerm("");
                      }}
                      title={c.name}
                    >
                      {inCartCount > 0 && (
                        <span className="dp-family-square-badge">
                          {inCartCount}
                        </span>
                      )}
                      <span className="dp-family-square-icon">{c.icon || "📦"}</span>
                      <span
                        className="dp-family-square-label"
                        style={{ color: isActive ? "#ffffff" : "#0f172a" }}
                      >
                        {c.name.split(" ")[0]}
                      </span>
                    </button>
                  );
                })}
              </div>
            </div>

            {/* Grille des articles */}
            {displayedArticles.length === 0 ? (
              <div style={{ textAlign: "center", padding: "40px", color: "#94a3b8" }}>
                <span style={{ fontSize: "3rem" }}>📦</span>
                <h5>Aucun article dans cette sélection</h5>
                <button
                  className="dp-btn dp-btn-primary mt-2"
                  onClick={() => setShowCustomModal(true)}
                >
                  ➕ Ajouter un article sur mesure
                </button>
              </div>
            ) : (
              <div className="dp-articles-grid">
                {/* Bouton rapide d'ajout libre */}
                <div
                  className="dp-article-card dp-custom-item-card"
                  onClick={() => setShowCustomModal(true)}
                >
                  <span style={{ fontSize: "1.8rem" }}>➕</span>
                  <div style={{ fontWeight: "800", fontSize: "0.9rem" }}>
                    Article Spécifique
                  </div>
                  <span style={{ fontSize: "0.75rem" }}>
                    Demande hors catalogue
                  </span>
                </div>

                {displayedArticles.map((art) => (
                  <div
                    key={art.id}
                    className="dp-article-card"
                    onClick={() => addToCart(art)}
                  >
                    <div>
                      <div className="dp-article-top">
                        <span className="dp-article-badge">
                          {art.categoryIcon} {art.unit}
                        </span>
                      </div>
                      <div className="dp-article-name">{art.articleName}</div>
                      <div className="dp-article-unit">{art.categoryName}</div>
                    </div>

                    <div className="dp-article-bottom">
                      <div className="dp-article-price">
                        {art.estimatedUnitPrice > 0
                          ? `${art.estimatedUnitPrice.toFixed(3)} DT`
                          : "Prix à chiffrer"}
                      </div>
                      <button className="dp-add-btn" title="Ajouter au panier">
                        +
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>

      {/* ── PANIER TACTILE D'ACHATS (DROITE) ── */}
      <div className="dp-pos-cart">
        <div className="dp-cart-header">
          <div className="dp-cart-title">
            🛒 Demande d'Achat
            <span className="dp-cart-count-badge">{totalItemsCount}</span>
          </div>
          {cart.length > 0 && (
            <button className="dp-cart-clear-btn" onClick={clearCart}>
              Vider
            </button>
          )}
        </div>

        <div className="dp-cart-body">
          {cart.length === 0 ? (
            <div className="dp-cart-empty">
              <span className="dp-cart-empty-icon">🛒</span>
              <h5 style={{ fontWeight: "700", color: "#64748b" }}>
                Panier Vide
              </h5>
              <p style={{ fontSize: "0.85rem" }}>
                Touchez une famille pour voir et ajouter ses articles à la demande d'achat.
              </p>
            </div>
          ) : (
            cart.map((item, idx) => (
              <div key={idx} className="dp-cart-item">
                <div className="dp-cart-item-header">
                  <div>
                    <div className="dp-cart-item-name">{item.articleName}</div>
                    <div className="dp-cart-item-cat">
                      {item.categoryName} ({item.unit})
                    </div>
                  </div>
                  <button
                    className="dp-cart-item-delete"
                    onClick={() => removeItem(idx)}
                    title="Supprimer l'article"
                  >
                    🗑️
                  </button>
                </div>

                <div className="dp-cart-item-actions">
                  {/* Stepper tactile de quantité */}
                  <div className="dp-qty-stepper">
                    <button
                      className="dp-stepper-btn"
                      onClick={() => updateQuantity(idx, -1)}
                    >
                      -
                    </button>
                    <input
                      type="number"
                      min="0.1"
                      step="any"
                      className="dp-stepper-input"
                      value={item.requestedQuantity}
                      onChange={(e) =>
                        handleDirectQuantityChange(idx, e.target.value)
                      }
                    />
                    <button
                      className="dp-stepper-btn"
                      onClick={() => updateQuantity(idx, 1)}
                    >
                      +
                    </button>
                  </div>

                  <div className="dp-cart-item-total">
                    {item.estimatedUnitPrice > 0
                      ? `${(
                          item.requestedQuantity * item.estimatedUnitPrice
                        ).toFixed(3)} DT`
                      : "— DT"}
                  </div>
                </div>
              </div>
            ))
          )}
        </div>

        {/* Pied du Panier */}
        <div className="dp-cart-footer">
          <div className="dp-priority-row">
            <span className="dp-priority-label">Urgence :</span>
            <select
              className="dp-priority-select"
              value={priority}
              onChange={(e) => setPriority(e.target.value)}
            >
              <option value="normal">🟢 Normal</option>
              <option value="urgent">🟠 Urgent</option>
              <option value="tres_urgent">🔴 Très Urgent (Immédiat)</option>
            </select>
          </div>

          <textarea
            placeholder="Notes ou détails supplémentaires pour le contrôleur..."
            value={generalNotes}
            onChange={(e) => setGeneralNotes(e.target.value)}
            rows="2"
            style={{
              width: "100%",
              padding: "8px 12px",
              borderRadius: "8px",
              border: "1px solid #cbd5e1",
              fontSize: "0.82rem",
              outline: "none",
              resize: "none"
            }}
          />

          <div className="dp-cart-summary-line">
            <span className="dp-cart-total-label">Montant Estimé :</span>
            <span className="dp-cart-total-value">
              {totalEstimatedCost.toFixed(3)} DT
            </span>
          </div>

          <button
            className="dp-submit-request-btn"
            disabled={cart.length === 0 || submitting}
            onClick={handleSubmitRequest}
          >
            {submitting ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                ></span>
                Envoi en cours...
              </>
            ) : (
              <>🚀 Envoyer au Contrôleur</>
            )}
          </button>
        </div>
      </div>

      {/* ── MODALE AJOUT ARTICLE PERSONNALISÉ ── */}
      <Modal
        show={showCustomModal}
        onHide={() => setShowCustomModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontWeight: "800" }}>
            ➕ Article Hors Catalogue
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <label className="form-label font-weight-bold">
              Nom de l'article *
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Ex: Rallonge 10m, Câble HDMI, Réparation serrure..."
              value={customItem.articleName}
              onChange={(e) =>
                setCustomItem({ ...customItem, articleName: e.target.value })
              }
            />
          </div>

          <div className="row mb-3">
            <div className="col-6">
              <label className="form-label font-weight-bold">Famille</label>
              <select
                className="form-control"
                value={customItem.categoryName}
                onChange={(e) =>
                  setCustomItem({ ...customItem, categoryName: e.target.value })
                }
              >
                {categories.map((c) => (
                  <option key={c._id || c.name} value={c.name}>
                    {c.icon} {c.name}
                  </option>
                ))}
                <option value="Autre / Exceptionnel">Autre / Exceptionnel</option>
              </select>
            </div>
            <div className="col-6">
              <label className="form-label font-weight-bold">Unité</label>
              <input
                type="text"
                className="form-control"
                placeholder="pièce, boîte, mètre..."
                value={customItem.unit}
                onChange={(e) =>
                  setCustomItem({ ...customItem, unit: e.target.value })
                }
              />
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-6">
              <label className="form-label font-weight-bold">
                Quantité demandée *
              </label>
              <input
                type="number"
                min="0.1"
                step="any"
                className="form-control"
                value={customItem.requestedQuantity}
                onChange={(e) =>
                  setCustomItem({
                    ...customItem,
                    requestedQuantity: e.target.value
                  })
                }
              />
            </div>
            <div className="col-6">
              <label className="form-label font-weight-bold">
                Prix estimé unitaire (DT)
              </label>
              <input
                type="number"
                min="0"
                step="0.1"
                className="form-control"
                value={customItem.estimatedUnitPrice}
                onChange={(e) =>
                  setCustomItem({
                    ...customItem,
                    estimatedUnitPrice: e.target.value
                  })
                }
              />
            </div>
          </div>

          <div className="mb-3">
            <label className="form-label font-weight-bold">
              Justification / Motif
            </label>
            <textarea
              className="form-control"
              rows="2"
              placeholder="Pourquoi cet article est nécessaire ?"
              value={customItem.notes}
              onChange={(e) =>
                setCustomItem({ ...customItem, notes: e.target.value })
              }
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowCustomModal(false)}
          >
            Annuler
          </Button>
          <Button
            variant="primary"
            onClick={handleAddCustomItem}
            disabled={!customItem.articleName.trim()}
          >
            Ajouter au panier
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ── MODALE SUCCÈS DEMANDE TRANSMIS ── */}
      <Modal
        show={!!successModal}
        onHide={() => setSuccessModal(null)}
        size="lg"
        centered
        className="dp-custom-modal-root"
      >
        <Modal.Header closeButton style={{ background: "linear-gradient(135deg, #15803d 0%, #166534 100%)", color: "white" }}>
          <Modal.Title style={{ color: "#ffffff", fontWeight: "800", display: "flex", alignItems: "center", gap: "10px" }}>
            <span>✅</span>
            <span>Demande d'Achat Transmise au Contrôleur !</span>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ padding: "22px 26px" }}>
          {/* Bannière récapitulative */}
          <div
            style={{
              background: "#f0fdf4",
              border: "1.5px solid #bbf7d0",
              borderRadius: "14px",
              padding: "14px 18px",
              marginBottom: "18px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "12px"
            }}
          >
            <div>
              <div style={{ fontSize: "0.82rem", color: "#166534", fontWeight: "700" }}>
                RÉFÉRENCE OFFICIELLE :
              </div>
              <div style={{ fontSize: "1.25rem", fontWeight: "900", color: "#14532d" }}>
                {successModal?.reference}
              </div>
              <div style={{ fontSize: "0.88rem", color: "#475569", marginTop: "2px" }}>
                📍 Emplacement : <strong>{successModal?.locationName}</strong>
              </div>
            </div>

            <div style={{ textAlign: "right" }}>
              <span
                style={{
                  display: "inline-block",
                  padding: "4px 12px",
                  borderRadius: "20px",
                  fontSize: "0.82rem",
                  fontWeight: "800",
                  background:
                    successModal?.priority === "tres_urgent"
                      ? "#fee2e2"
                      : successModal?.priority === "urgent"
                      ? "#fef3c7"
                      : "#e2e8f0",
                  color:
                    successModal?.priority === "tres_urgent"
                      ? "#dc2626"
                      : successModal?.priority === "urgent"
                      ? "#d97706"
                      : "#334155"
                }}
              >
                {successModal?.priority === "tres_urgent"
                  ? "🔴 Très Urgent"
                  : successModal?.priority === "urgent"
                  ? "🟠 Urgent"
                  : "🟢 Normal"}
              </span>
              <div style={{ fontSize: "0.82rem", color: "#64748b", marginTop: "4px" }}>
                Statut : <strong>⏳ En attente de contrôle</strong>
              </div>
            </div>
          </div>

          {/* Tableau détaillé et lisible des articles à acheter */}
          <h5
            style={{
              fontWeight: "800",
              color: "#0f172a",
              marginBottom: "10px",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              fontSize: "1.05rem"
            }}
          >
            <span>🛒</span>
            <span>Articles Commandés ({successModal?.items?.length || 0}) :</span>
          </h5>

          <div
            style={{
              border: "1.5px solid #e2e8f0",
              borderRadius: "12px",
              overflow: "hidden",
              marginBottom: "16px"
            }}
          >
            <table className="dp-table" style={{ margin: 0 }}>
              <thead style={{ background: "#f8fafc" }}>
                <tr>
                  <th style={{ width: "40px", textAlign: "center" }}>#</th>
                  <th>Article / Désignation</th>
                  <th>Famille</th>
                  <th style={{ textAlign: "center" }}>Quantité</th>
                  <th style={{ textAlign: "right" }}>Prix Estimé (DT)</th>
                  <th style={{ textAlign: "right" }}>Total Estimé (DT)</th>
                </tr>
              </thead>
              <tbody>
                {successModal?.items?.map((it, idx) => (
                  <tr
                    key={idx}
                    style={{ background: idx % 2 === 0 ? "#ffffff" : "#fcfcfd" }}
                  >
                    <td
                      style={{
                        textAlign: "center",
                        fontWeight: "700",
                        color: "#94a3b8"
                      }}
                    >
                      {idx + 1}
                    </td>
                    <td>
                      <div
                        style={{
                          fontWeight: "800",
                          color: "#0f172a",
                          fontSize: "0.95rem"
                        }}
                      >
                        {it.articleName}
                      </div>
                      {it.notes && (
                        <div
                          style={{
                            fontSize: "0.78rem",
                            color: "#0284c7",
                            fontStyle: "italic",
                            marginTop: "2px"
                          }}
                        >
                          💬 Note : {it.notes}
                        </div>
                      )}
                    </td>
                    <td>
                      <span
                        style={{
                          fontSize: "0.82rem",
                          padding: "3px 8px",
                          background: "#f1f5f9",
                          borderRadius: "6px",
                          fontWeight: "600",
                          color: "#475569"
                        }}
                      >
                        {it.categoryName}
                      </span>
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <span
                        style={{
                          fontWeight: "800",
                          background: "#eff6ff",
                          color: "#1d4ed8",
                          padding: "4px 10px",
                          borderRadius: "8px",
                          fontSize: "0.92rem",
                          border: "1px solid #bfdbfe"
                        }}
                      >
                        {it.requestedQuantity} {it.unit}
                      </span>
                    </td>
                    <td
                      style={{
                        textAlign: "right",
                        fontWeight: "600",
                        color: "#475569"
                      }}
                    >
                      {(Number(it.estimatedUnitPrice) || 0).toFixed(3)}
                    </td>
                    <td
                      style={{
                        textAlign: "right",
                        fontWeight: "800",
                        color: "#0f172a",
                        fontSize: "0.95rem"
                      }}
                    >
                      {(
                        Number(it.estimatedTotalPrice) ||
                        Number(it.requestedQuantity) *
                          Number(it.estimatedUnitPrice) ||
                        0
                      ).toFixed(3)}{" "}
                      DT
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot
                style={{ background: "#f1f5f9", borderTop: "2px solid #cbd5e1" }}
              >
                <tr>
                  <td
                    colSpan="5"
                    style={{
                      textAlign: "right",
                      fontWeight: "800",
                      fontSize: "0.95rem",
                      color: "#0f172a"
                    }}
                  >
                    TOTAL ESTIMÉ DE LA COMMANDE :
                  </td>
                  <td
                    style={{
                      textAlign: "right",
                      fontWeight: "900",
                      fontSize: "1.15rem",
                      color: "#15803d"
                    }}
                  >
                    {(
                      successModal?.totalEstimatedAmount ||
                      (successModal?.items || []).reduce(
                        (sum, item) =>
                          sum +
                          (Number(item.estimatedTotalPrice) ||
                            Number(item.requestedQuantity) *
                              Number(item.estimatedUnitPrice) ||
                            0),
                        0
                      )
                    ).toFixed(3)}{" "}
                    DT
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>

          {successModal?.generalNotes && (
            <div
              style={{
                background: "#f8fafc",
                border: "1px solid #e2e8f0",
                borderRadius: "10px",
                padding: "10px 14px",
                fontSize: "0.85rem",
                color: "#334155"
              }}
            >
              <strong>Remarques générales :</strong>{" "}
              {successModal.generalNotes}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer
          style={{
            background: "#f8fafc",
            padding: "14px 24px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "10px"
          }}
        >
          <Button
            variant="secondary"
            style={{
              fontWeight: "750",
              padding: "10px 20px",
              fontSize: "0.92rem",
              borderRadius: "10px"
            }}
            onClick={() => setSuccessModal(null)}
          >
            ➕ Saisir une autre demande
          </Button>

          {onNavigateToSuivi ? (
            <Button
              variant="primary"
              style={{
                fontWeight: "800",
                padding: "10px 24px",
                fontSize: "0.95rem",
                borderRadius: "10px"
              }}
              onClick={() => {
                setSuccessModal(null);
                onNavigateToSuivi();
              }}
            >
              📦 Suivre ma demande en direct ➔
            </Button>
          ) : (
            <Button
              variant="success"
              style={{
                fontWeight: "800",
                padding: "10px 24px",
                fontSize: "0.95rem",
                borderRadius: "10px"
              }}
              onClick={() => setSuccessModal(null)}
            >
              ✅ Compris & Continuer
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CaisseAchatTactile;
